// LimitText Class
import { LimitText } from "../classes/LimitText";

const cardsParagraph = document.querySelectorAll("#news-details .similar-news .card .card-text");
const newsContentParagraph = document.querySelectorAll(".news-content p");


cardsParagraph.forEach( (paragraph) => {
    let limit = 100;
    let inputText = paragraph.innerHTML;
    if ( inputText.length > limit ) {
        let limit_Text_size = new LimitText(inputText, limit);
        paragraph.innerHTML = limit_Text_size.limitOutput;
    }
});
function replaceNbsps(str) {
    var re = new RegExp(String.fromCharCode(10), "g");
    return str.trim().replace(re, "<br>");
}
newsContentParagraph.forEach( (paragraph) => {
    paragraph.innerHTML = replaceNbsps(paragraph.innerHTML);
});